import React from 'react';
import styled from 'styled-components';
import { portalCardsContainerStyle, portalCardsContainerWithSidebarStyle } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';

interface TopicsRootProps {
    isCustomizing: boolean;
}

export const TopicsRoot: React.FC<React.PropsWithChildren<TopicsRootProps>> = ({ children, isCustomizing }) => {
    return <Root className={isCustomizing ? 'sidebar-opened' : 'sidebar-closed'}>{children}</Root>;
};

const Root = styled.section`
    align-self: center;
    width: 100%;
    align-items: center;
    &.sidebar-opened {
        ${portalCardsContainerWithSidebarStyle}
    }
    &.sidebar-closed {
        ${portalCardsContainerStyle}
    }
    margin-top: ${token('space.400', '32px')};
`;
